export default __webpack_public_path__ + "static/media/UploadIcon.b170ec0d.svg";